import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { AlertCircle, Network as NetworkIcon } from 'lucide-react'
import { useReferralNetwork } from '@/hooks'
import { NetworkGraph } from '@/components/referrals/network-graph'
import { NetworkStats } from '@/components/referrals/network-stats'
import { NetworkFilters } from '@/components/referrals/network-filters'

export const Route = createFileRoute('/_app/referrals/network')({
  component: NetworkPage,
})

function NetworkPage() {
  const [minReferrals, setMinReferrals] = useState(1) // Default: only show members with at least 1 referral
  const [statusFilter, setStatusFilter] = useState<string>('active')

  const filters = {
    status: statusFilter,
    minReferrals: minReferrals,
  }

  const { data, isLoading, error } = useReferralNetwork(filters)

  if (error) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center space-y-2">
          <AlertCircle className="h-8 w-8 text-destructive mx-auto" />
          <p className="text-muted-foreground">Erro ao carregar rede de indicações</p>
          <p className="text-sm text-destructive">{error.message}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <NetworkIcon className="h-8 w-8" />
          <h1 className="text-3xl font-bold tracking-tight">Rede de Indicações</h1>
        </div>
        <p className="text-muted-foreground">
          Visualize todas as conexões e relacionamentos de membros
        </p>
      </div>

      {!isLoading && data && <NetworkStats stats={data.stats} />}

      <NetworkFilters
        filters={filters}
        onFiltersChange={(newFilters) => {
          if (newFilters.status !== undefined) setStatusFilter(newFilters.status)
          if (newFilters.minReferrals !== undefined) setMinReferrals(newFilters.minReferrals)
        }}
      />

      <NetworkGraph data={data} isLoading={isLoading} />
    </div>
  )
}
